import { createContext } from "react";
import { PopBottomSheetData } from "..";

export type PopBottomSheetContextType = {

  /**
   *  
   */
  showPopBottomSheet       : (data:PopBottomSheetData) => void,

};

export type PopBottomSheetContainerProps = {

  onHide  : () => void;
  data?   : PopBottomSheetData;

}

const PopBottomSheetContext = createContext<PopBottomSheetContextType>({} as PopBottomSheetContextType);
      PopBottomSheetContext.displayName = "ITDPopBottomSheetContext";

export default PopBottomSheetContext;